import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WithdrawalBaseComponent } from './withdrawal-base.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  declarations: [
    WithdrawalBaseComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class WithdrawalBaseModule { }
